import { Search,AccountHeadDetails } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-grievence-addressing',
  templateUrl: './grievence-addressing.component.html',
  styleUrls: ['./grievence-addressing.component.css']
})
export class GrievenceAddressingComponent implements OnInit {
  title ="Grievance Lodging";
  GrievancesLodging: any={};  
  UserName: string;
  RoleName: string;
  fileToUpload: File;
  formInvalid: boolean;
  fileNotUploaded:boolean;
  mode: any;
  Id: any;  
  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) {
    
   }
  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.mode = params['mode'];
      this.Id = params['Id'];
    });
    if (this.mode=='view' || this.mode=='edit')
    {
      if (this.mode=='view')
      this.title="View Grievance";
      else
      this.title="Edit Grievance";
      this.GetGrievanceById(this.Id);
    }
    
  }
  GetGrievanceById(Id:number)
  {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getGrievanceById(this.Id)
      .subscribe(
        (data) => {
          this.GrievancesLodging = data;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  UpdateGrievances(form:NgForm)
  {
    if (!form.invalid)
    {
      document.getElementById('loader-spinner').style.display = "block";
      this.GrievancesLodging.Id=this.Id;
      this.userService.UpdateSainikGrievances(this.GrievancesLodging).subscribe((response)=>{
        document.getElementById('loader-spinner').style.display = "none";
        swal("Success!","Status Updated Successfully");
        this.router.navigate(['/home/ga']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      }); 
    }       
      else
      {
        document.getElementById('loader-spinner').style.display = "none";
        this.formInvalid = true;        
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/Grievances-Addressing/grievence-addressing/grievence-addressing.component.ts